<template>
  <v-dialog v-model="isOpenDialog" width="40%" class="dialog" :fullscreen="$vuetify.breakpoint.smAndDown">
    <v-card>
      <v-card-title class="primary white--text">
        <v-toolbar-title>{{ titleDialog }}</v-toolbar-title>
        <v-spacer />
        <v-icon color="white" @click="cancel">close</v-icon>
      </v-card-title>
      <v-divider></v-divider>
      <v-form ref="form" flat class="pa-3">
        <div class="d-flex">
          <v-col cols="12" md="12" class="pb-0">
            <v-text-field
              ref="title"
              v-model="title"
              label="Nhóm đối tượng"
              outlined
              required
              dense
              class="required"
              :rules="[rule]"
            >
            </v-text-field>
          </v-col>
        </div>
      </v-form>
      <div class="py-10"></div>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn outlined class="ma-2" @click="cancel">Hủy</v-btn>
        <v-spacer />
          <v-btn depressed class="px-6 mr-4 mt-n4 mb-2 white--text" :loading="loading" :disabled="loading" color="primary"
            @click="save">
            Lưu
          </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  props: {
    action: String,
    type: String
  },
  data() {
    return {
      isOpenDialog: false,
      title: '',
      loading: false,
      rule: this.$rules.required
    }
  },
  computed: {
    ...mapGetters({
      group: 'tuitionFeeGroup/groupInfo'
    }),
    titleDialog() {
      if (this.action === 'update') return 'SỬA HỒ SƠ CHI TIẾT'
      else return 'THÊM NHÓM MỚI'
    }
  },
  methods: {
    ...mapActions('tuitionFeeGroup', ['createGroup', 'updateGroup']),
    cancel() {
      this.isOpenDialog = false
      this.$refs.form.reset()
    },
    async save() {
      this.loading = true
      if (this.title) {
        this.title = this.title.replace(/\s+/g, ' ').trim()
        if (this.action === 'update') {
          try {
            await this.updateGroup({
              title: this.title,
              id: this.group.id
            })
            this.$alert.updateSuccess()
            this.isOpenDialog = false
          } catch (err) {
            let msg = this.$options.filters.isConnect(err, 'Tên nhóm đã tồn tại')
            this.$alert.updateError(msg)
          }
        } else if (this.action === 'create') {
          this.title = this.title.trim()

          try {
            await this.createGroup({
              title: this.title,
              category: 'custom',
              type: this.type
            })
            this.$alert.addSuccess()
            this.$refs.form.reset()
            this.$emit('addGroupSuccess')
            this.isOpenDialog = false
          } catch (err) {
            let msg = this.$options.filters.isConnect(err, 'Tên nhóm đã tồn tại')
            this.$alert.addError(msg)
          }
        }
      } else {
        this.rule = this.$rules.required
        this.$refs.form.validate()
      }
      this.loading = false
    },
    openDialog() {
      this.isOpenDialog = true
      if (this.group && this.group.title && this.action === 'update') this.title = this.group.title
    }
  }
}
</script>
